module.exports = __webpack_public_path__ + "img/FGr_Räumen_B.a7adb3e8.svg";